import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  tabTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '16px',
    color: '#2C2D3E',
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    color: '#2C2D3E',
    margin: '10px 15px 5px 5px',
  },
  subTitleDisabled: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  note: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '11px',
    color: '#2C2D3E',
    margin: '10px 15px 5px 5px',
    paddingTop: '25px'
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },  
  itemTextField: {
    padding: '10px 15px 5px 5px',
  },
  itemWithRadioGroup: {
    padding: '0px 5px 10px 5px',
  }, 
  label: {
    marginRight: '5px', 
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '13px',
  },
  itemIdTypeRow: {
    paddingBottom: '25px'
  },
  helperRow: {
    height: '30px',
    paddingTop: '5px',
  },
  errorMessage: {
    display: 'inline',
    fontFamily: 'Roboto',
    color: '#BC0000',
    fontWeight: 400,
    fontSize: '12px',
  }
}));
